
/**
 * Action dispatched when the background effect is enabled or disabled.
 *
 * @returns {{
 *     type: BACKGROUND_ENABLED,
 *     backgroundEffectEnabled: boolean,
 * }}
 */
export const BACKGROUND_ENABLED = 'BACKGROUND_ENABLED';

/**
 * Action dispatched to set the virtual background configuration.
 *
 * @returns {{
 *     type: SET_VIRTUAL_BACKGROUND,
 *     virtualSource: string,
 *     backgroundType: string,
 *     blurValue: number,
 *     selectedThumbnail: string,
 * }}
 */
export const SET_VIRTUAL_BACKGROUND = 'SET_VIRTUAL_BACKGROUND';

/**
 * Action dispatched to add/update custom uploaded images.
 *
 * @returns {{
 *     type: ADD_CUSTOM_IMAGE,
 *     customImages: Array<Object>,
 * }}
 */
export const ADD_CUSTOM_IMAGE = 'ADD_CUSTOM_IMAGE';

/**
 * Action dispatched to reset virtual background to default state.
 *
 * @returns {{
 *     type: RESET_VIRTUAL_BACKGROUND,
 * }}
 */
export const RESET_VIRTUAL_BACKGROUND = 'RESET_VIRTUAL_BACKGROUND';
